import { Injectable } from '@angular/core';

import {
  ICareTrackerBalanceResponseDTO,
  ICareTrackerConsumer,
} from '../../interfaces/caretracker/caretracker-balance-response.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  fullPaymentAmount: string;
  maxLength: number;
  SCAccountNumber: string;
  balance: string;
  name: string;
  card?: string;
  amount?: string;
  partialPaymentAmount?: string;
  lastFour?: string;
  date: string;
  vendorPatientId: string;
  patientId: string;
  SCgroupId?: string;
  CTBalance?: ICareTrackerBalanceResponseDTO;
  accountNumber: string;
  fullscreen: string;
  receiptDetails: string;
  consumer?: ICareTrackerConsumer;
  choosenPlanAmount?: string;
  choosenPlan: number;
  selectedPlanAmount?: string;
  selectedPlan: number;
  fullPayment: boolean;
  partialPayment: boolean;
  paymentPlanPayment: boolean;
  isActivePaymentPlan?: boolean;
  nextTransactionDate?: string;
}
